import { useQuery } from "@tanstack/react-query";
import { getTimeSheetSearchSuggestions } from "../actions/getTimeSheetSearchSuggestions.actions";
import { TimeSheetSearchSuggestionsParams } from "../interfaces/time-sheet.interfaces";

export const useTimeSheetSearchSuggestionsQuery = (params: TimeSheetSearchSuggestionsParams) => {
  return useQuery({
    queryKey: ["time-sheet-search-suggestions", params],
    queryFn: () => getTimeSheetSearchSuggestions(params),
    enabled: Boolean(params.search?.trim()),
    staleTime: 30_000,
  });
};
